import styled from "styled-components";

import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledListContainer = styled(FlexColumn)``;

export const StyledListItemsContainer = styled(FlexColumn)``;
